<template>
  <div class="wrapper">
    <div v-for="(item, index) in allItems" :key="item.id" class="wrapper-description" :class="[
      borderRadius ? `wrapper-description_br-${borderRadius}` : '',]"
    >

      <div v-if="index !== activeIndexMain || currentWidth < 768"
           class="wrapper-description_unactive"
           :class="[`wrapper-description_unactive-${index}`]"
           @click="changeMainIndex(index)"
           :style="{height: currentHeightUnactiveItem }"
      >
        <div class="unactive_title" v-if="currentWidth >= 768 && item.name">
          <span>{{ $t(item.name) }}</span>
        </div>
        <img :src="item.content[0].images[0]" alt="altImageDefault"/>
      </div>

      <div
        class="wrapper-description_active"
        :style="{
          maxWidth: maxWidth,
          minHeight: currentHeightBlockWithActiveItem,
        }"
        v-if="index === activeIndexMain"
      >
        <div class="content__count-items" v-if="acitveTypeItems !== 'tour' && isMount">
          <div class="content__count-img"
               @click="chooseItemActive(item, index2)"
               :class="{ 'content__count-img_active': index2 === choosenItem }"
               v-for="(item, index2) in activeItemSlide">
          </div>
        </div>
        <div class="content__description" ref="descriptionRef">
          <div class="description__wrapper">
            <div class="type-btns">
              <SvgOfferPhotoSvg
                :width="currentWidth < 768 ? 35 : 40"
                :height="currentWidth < 768 ? 35 : 40"
                :bg-color="currentWidth < 768? acitveTypeItems === 'images'? 'var(--var-blue-50)' : 'none'  : 'var(--var-white-000)'"
                :color="acitveTypeItems === 'images'? currentWidth < 768? 'var(--var-white-000)': 'var(--var-blue-50)' : currentWidth < 768? 'var(--var-black-200)': 'var(--var-white-000)'"
                :opacity="acitveTypeItems === 'images' ? 1 : 0.1"
                @click="chooseActiveTypeItemsHandler('images')"
              />
              <SvgOfferVideoSvg
                :width="currentWidth < 768 ? 35 : 40"
                :height="currentWidth < 768 ? 35 : 40"
                :bg-color="currentWidth < 768? acitveTypeItems === 'video'? 'var(--var-blue-50)' : 'none' : 'var(--var-white-000)'"
                :color="acitveTypeItems === 'video'? currentWidth < 768? 'var(--var-white-000)': 'var(--var-blue-50)' : currentWidth < 768? 'var(--var-black-200)': 'var(--var-white-000)'"
                :opacity="acitveTypeItems === 'video' ? 1 : 0.1"
                @click="chooseActiveTypeItemsHandler('video')"
              />
              <SvgOfferTourSvg
                :width="currentWidth < 768 ? 35 : 40"
                :height="currentWidth < 768 ? 35 : 40"
                :bg-color="currentWidth < 768? acitveTypeItems === 'tour'? 'var(--var-blue-50)' : 'none'  : 'var(--var-white-000)'"
                :color="acitveTypeItems === 'tour' ? currentWidth < 768? 'var(--var-white-000)': 'var(--var-blue-50)' : currentWidth < 768 ? 'var(--var-black-200)': 'var(--var-white-000)'"
                :opacity="acitveTypeItems === 'tour' ? 1 : 0.1"
                @click="chooseActiveTypeItemsHandler('tour')"
              />
            </div>
            <div class="description">
              <h3>{{ $t(activeItemDesc.title) }}</h3>
              <p>{{ $t(activeItemDesc.description) }}</p>
            </div>
          </div>
          <div class="author-btns" v-if="allItemDesc.length > 1">
            <div v-for="(author, index) in allItemDesc" :key="author.title" class="title"
                 :class="{ title_active: author.id === activeItemDesc.id }" @click="changeAuthorIndex(index)">
              {{ $t(author.title) }}
            </div>
          </div>
        </div>
        <div class="carousel" @mousemove="dragging" @mousedown="dragStart" @mouseup="dragStop" @mouseleave="dragStop"
             @touchstart="dragStart" @touchmove="dragging" @touchend="dragStop" ref="videoSliderRef">
          <div v-if="acitveTypeItems === 'video'" class="video">
            <div v-for="(video, index) in activeItemSlide">
              <div v-if="!isMobile" class="loader__wrapper" :key="video.src" :style="{
                left: `calc(${index * firstImgWidth + 'px'}`,
                zIndex: loadVideoForStart[
                  isMobile ? video.srcMobile : video.src] ? -1 : 1,
              }">
                <UiLoader :radius="10" color="var(--var-blue-100)" :circle-width="2"/>
              </div>
            </div>
            <video v-for="(video, index) in activeItemSlide" :id="isMobile ? video.srcMobile : video.src"
                   :key="video.src"
                   :class="{
                'gallery-video-loop_first': index === 0,
                'gallery-video-loop': true,
              }"
                   :controls="isMobile" autoplay autobuffer loop playsinline webkit-playinginline muted
                   :ref="index === 0 ? 'videoFirstRef' : undefined" draggable="false"
                   @canplaythrough="isLoadEnoughVideo(isMobile ? video.srcMobile : video.src)"
                   @error="handErrorLoadVideo($event, isMobile ? video.srcMobile : video.src)"
                   @click="videoClickHandler(isMobile ? video.srcMobile : video.src, index)">
              <source v-if="videoRange?.includes(index)" :src="video.src" type="video/mp4"
                      :media="'(min-width: 1128px)'"/>
              <source v-if="videoRange?.includes(index)" :src="video.srcMobile" type="video/mp4"
                      :media="'(max-width: 1128px)'"/>
            </video>
          </div>
          <div v-else-if="acitveTypeItems === 'images'" class="images">
            <div v-for="(image, index) in activeItemSlide">
              <div class="loader__wrapper" :key="image" :style="{
                left: `calc(${index * firstImgWidth + 'px'}`,
                zIndex: loadImageForStart[image] ? -1 : -1,
              }">
                <UiLoader :radius="10" color="var(--var-blue-100)" :circle-width="2"/>
              </div>
            </div>
            <img v-for="(images, index) in activeItemSlide" :id="images" @click="openInFullSizeHandler(images, index)"
                 :key="images" :src="images" :ref="index === 0 ? 'videoFirstRef' : undefined" :class="{
                'gallery-video-loop_first': index === 0,
                'gallery-video-loop': true,
              }" @load="imageLoadHandler(images)" alt="altImageDefault"/>
          </div>
          <div v-else-if="acitveTypeItems === 'tour'">
            <div class="gallery-carusel-wrp">
              <div class="panorama-wrp">
                <iframe class="panorama-item" :src="baseUrl + activeItemSlide" height="100%"
                        :style="{ maxWidth: maxWidth, width: '100%' }" @load="loadTourHandler(activeItemSlide)"/>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>

  <div class="flex flex-center items-center" v-if="currentWidth <= 768">
    <UiButtonArrowContainer>
      <UiButtonArrow
        :right="false"
        :disabled="!canSlideLeft()"
        @click="slideLeft"
      />
      <UiButtonArrow
        :right="true"
        :disabled="!canSlideRight()"
        @click="slideRight"
      />
    </UiButtonArrowContainer>
  </div>

  <UiModalsFullScreenModalV2 v-if="isOpenFullScreenModal"
                             :typeItems="acitveTypeItems"
                             :items="activeItemSlide"
                             :posters="posters"
                             :item-active="currentIndexFullScreenImg"
                             :is-need-additional-block="false"
                             @close-action="closeActionHandler"
                             bg-color="transparent"/>
</template>

<script setup lang="ts">
import {ref} from 'vue';
import {useRuntimeConfig} from '#imports';
import {useBaseStore} from '~/modules/BaseModule/base.store';

const props = withDefaults(
  defineProps<{
    items: any;
    posters?: { videoSrc: string; value: string }[];
    maxWidth: string;
    minWidth: string;
    borderRadius?: number;
  }>(),
  {
    items: [],
    maxWidth: '924px',
    minWidth: '924px',
  },
);
const runtimeConfig = useRuntimeConfig();
const allItems = ref(props.items);
const isMount = ref(false);
const activeIndexMain = ref(0);
const allItemDesc = ref(props.items[activeIndexMain.value].content);
const activeItemDesc = ref(
  props.items[activeIndexMain.value].content[0],
);
const activeItemSlide = ref(
  props.items[activeIndexMain.value].content[0].images,
);
const acitveTypeItems = ref<'images' | 'video' | 'tour'>('images');
const activeAuthorItem = ref(0);
const base = useBaseStore();
const isMobile = computed(() => base.isMobile);
const baseUrl = runtimeConfig.public.vueAppBaseUrl;
const videoRange = ref<null | number[]>(null);
const loadVideoForStart = ref<{ [key: string]: boolean }>({});
const loadImageForStart = ref<{ [key: string]: boolean }>({});
const loadTourForStart = ref<{ [key: string]: boolean }>({});
const videoSliderRef = ref(null);
const descriptionRef = ref(null);
const videoFirstRef = ref(null);
const iconLeft = ref(null);
const iconRight = ref(null);
const currentIndexFullScreenImg = ref(0);
const currentHeightUnactiveItem = ref(`100%`);
const currentHeightBlockWithActiveItem = ref(`100%`);
const currentWidth = computed(() => base.currentWidth);

let positionDiff: number;
let firstImgWidth: number;
let isDragStart = false;
let prevPageX: number;
let prevScrollLeft: number;
let scrollWidth: number;
let isDragging = false;
const choosenItem = ref(0);
const isCanSlide = ref(true);
const isOpenFullScreenModal = ref(false);


/* SLIDE item for mobile by buttons*/
const slideLeft = () => {
  const index = canSlideLeft() ? 1 : 0;
  changeMainIndex(activeIndexMain.value - index);
}

const slideRight = () => {
  const index = canSlideRight() ? 1 : 0;
  changeMainIndex(activeIndexMain.value + index);
}

const canSlideLeft = () => {
  return activeIndexMain.value > 0;
}

const canSlideRight = () => {
  return activeIndexMain.value < allItems.value.length - 1;
}

const changeAuthorIndex = (index: number) => {
  acitveTypeItems.value = 'images';
  activeAuthorItem.value = index;
  activeItemDesc.value =
    props.items[activeIndexMain.value].content[index];
  activeItemSlide.value =
    props.items[activeIndexMain.value].content[
      activeAuthorItem.value
      ]?.[acitveTypeItems.value];
};

const changeMainIndex = (index: number) => {
  activeIndexMain.value = index;
  activeAuthorItem.value = 0;
  activeItemSlide.value =
    props.items[activeIndexMain.value].content[
      activeAuthorItem.value
      ]?.['images'];

  activeItemDesc.value =
    props.items[activeIndexMain.value].content[0];
  allItemDesc.value = props.items[activeIndexMain.value].content;
  acitveTypeItems.value = 'images';
};

const chooseActiveTypeItemsHandler = (
  type: 'images' | 'tour' | 'video',
) => {
  if (!activeItemDesc.value?.video?.length && type === 'video')
    return;
  acitveTypeItems.value = type;

  if (type === 'video') {
    activeItemSlide.value =
      props.items[activeIndexMain.value].content[
        activeAuthorItem.value
        ]?.[type];
    return;
  }
  activeItemSlide.value =
    props.items[activeIndexMain.value].content[
      activeAuthorItem.value
      ]?.[type];
};

const closeActionHandler = () => {
  isOpenFullScreenModal.value = false;
};

const isCanControlVideo = ref<{ [name: string]: boolean }>({});

const videoClickHandler = async (video: string, index: number) => {
  if (!isDragging) {
    // setTimeout(() => {
    if (!isMobile.value) {
      openInFullSizeHandler(video, index);
    }
    isCanControlVideo.value = {
      [video]: !isCanControlVideo.value[video],
    };
    if (!isCanControlVideo.value[video]) {
      await document.getElementById(video)?.play();
    }
    // }, 100);
  }
};

const openInFullSizeHandler = (item: string, index: number) => {
  if (!isDragging) {
    currentIndexFullScreenImg.value = index;
    isOpenFullScreenModal.value = true;
  }
};

const loadTourHandler = (currentTour: string) => {
  loadTourForStart.value = {
    ...loadTourForStart.value,
    [currentTour]: true,
  };
};

const imageLoadHandler = (currentImage: string) => {
  loadImageForStart.value = {
    ...loadImageForStart.value,
    [currentImage]: true,
  };
};

const isLoadEnoughVideo = (currentVideo: string) => {
  loadVideoForStart.value = {
    ...loadVideoForStart.value,
    [currentVideo]: true,
  };
};

const intervalLoadRef = ref<any>(null);

const handErrorLoadVideo = (e, video?: string) => {
  if (video) {
    const brokeVideo: HTMLVideoElement | null =
      document.getElementById(video) as HTMLVideoElement;
    if (brokeVideo) {
      intervalLoadRef.value = setTimeout(async () => {
        brokeVideo.pause();
        brokeVideo.load();
      }, 3000);
    }
  }
};

const showHideIcons = (isNeedChoosenItem?: boolean) => {
  if (videoSliderRef.value) {
    if (!isNeedChoosenItem) {
      choosenItem.value = Math.round(
        videoSliderRef.value[0].scrollLeft / firstImgWidth,
      );
    }

    if (iconLeft.value) {
      iconLeft.value.style.display =
        videoSliderRef.value[0].scrollLeft <= 120 ? 'none' : 'block';
    }

    if (iconRight.value) {
      iconRight.value.style.display =
        videoSliderRef.value[0].scrollLeft + 20 >= scrollWidth
          ? 'none'
          : 'block';
    }
  }
};

const chooseItemActive = (activeItem: string, index: number) => {
  choosenItem.value = index;
  let choosenItemById;
  if (acitveTypeItems.value === 'video') {
    if (isMobile.value) {
      choosenItemById = document.getElementById(activeItem.srcMobile);
      choosenItemById.src = activeItem.srcMobile;
    } else {
      choosenItemById = document.getElementById(activeItem.src);
      choosenItemById.src = activeItem.src;
    }
    setTimeout(() => choosenItemById.play(), 1000);
  } else choosenItemById = document.getElementById(activeItem);

  if (choosenItemById) {
    new Promise((res) => {
      if (videoSliderRef.value[0]) {
        videoSliderRef.value[0].scrollLeft =
          choosenItemById?.offsetLeft;
      }
      res('');
    }).then(() => {
      setTimeout(() => {
        showHideIcons(true);
      }, 1300);
    });
  }
};
const dragging = (e) => {
  if (videoSliderRef.value) {
    if (!isDragStart) return;

    if (currentWidth.value > 768) {
      e.preventDefault();
    }

    isDragging = true;
    videoSliderRef.value[0].classList.add('dragging');
    positionDiff = (e.pageX || e.touches[0].pageX) - prevPageX;
    videoSliderRef.value[0].scrollLeft =
      prevScrollLeft - positionDiff;
  }
};
const autoSlide = () => {
  if (
    acitveTypeItems.value === 'video' &&
    videoRange.value?.length !== activeItemSlide.value.length
  ) {
    videoRange.value = Array.from(
      Array(activeItemSlide.value.length).keys(),
    );
  }
  if (
    (videoSliderRef.value[0] &&
      videoSliderRef.value[0].scrollLeft -
      (videoSliderRef.value[0].scrollWidth -
        videoSliderRef.value[0].clientWidth) >
      -1) ||
    (videoSliderRef.value[0] &&
      videoSliderRef.value[0].scrollLeft <= 0)
  ) {
    return;
  }
  positionDiff = Math.abs(positionDiff);
  const additionalValueML = isMobile.value ? 10 : 14;
  firstImgWidth =
    videoSliderRef.value[0].clientWidth + additionalValueML;
  let valDifference = firstImgWidth - positionDiff;

  if (
    videoSliderRef.value[0] &&
    videoSliderRef.value[0].scrollLeft > prevScrollLeft
  ) {
    return (videoSliderRef.value[0].scrollLeft +=
      positionDiff > firstImgWidth / 5
        ? valDifference
        : -positionDiff);
  }
  if (videoSliderRef.value[0]) {
    return (videoSliderRef.value[0].scrollLeft -=
      positionDiff > firstImgWidth / 5
        ? valDifference
        : -positionDiff);
  }
};

const dragStart = (e) => {
  if (videoSliderRef.value[0]) {
    isDragStart = true;
    prevPageX = e.pageX || e.touches[0].pageX;
    prevScrollLeft = videoSliderRef.value[0].scrollLeft;
  }
};
const dragStop = (e) => {
  isDragStart = false;

  if (videoSliderRef.value[0]) {
    videoSliderRef.value[0].classList.remove('dragging');

    if (!isDragging) return;
    setTimeout(() => {
      isDragging = false;
    }, 0);
    new Promise((res, rej) => {
      const afterSlide = autoSlide();

      if (afterSlide % firstImgWidth !== 0) {
        videoSliderRef.value[0].scrollLeft =
          firstImgWidth *
          Math.round(
            videoSliderRef.value[0].scrollLeft / firstImgWidth,
          );
      }
      res('');
    }).then(() => {
      setTimeout(() => {
        showHideIcons();
      }, 600);
    });
  }
};

watch(
  () => [acitveTypeItems.value, isMobile.value],
  () => {
    if (videoSliderRef.value[0]) {
      if (acitveTypeItems.value === 'video') {
        videoRange.value = [0, 1];
      } else {
        loadVideoForStart.value = {};
      }
      videoSliderRef.value[0].scrollLeft = 0;
      const additionalValueML = isMobile.value ? 10 : 14;
      firstImgWidth =
        videoSliderRef.value[0].clientWidth + additionalValueML;
      setTimeout(() => {
        currentHeightUnactiveItem.value = `${videoSliderRef.value[0].clientHeight}px`;

        scrollWidth =
          videoSliderRef.value[0].scrollWidth -
          videoSliderRef.value[0].clientWidth;
      }, 100);
      setTimeout(() => {
        showHideIcons();
      }, 600);
    }
  },
);

watch(
  () => [isMobile.value],
  () => {
    currentHeightBlockWithActiveItem.value = `${videoSliderRef.value[0].clientHeight +
    (currentWidth.value < 768 ? 0 : 0)
    }px`;
  },
);

const resizeHandler = () => {
  currentWidth.value = window.innerWidth;

  if (videoFirstRef.value) {
    const additionalValueML = isMobile.value ? 10 : 14;
    firstImgWidth =
      videoSliderRef.value[0].clientWidth + additionalValueML;
    currentHeightUnactiveItem.value = `${videoSliderRef.value[0].clientHeight}px`;

    currentHeightBlockWithActiveItem.value = `${videoSliderRef.value[0].clientHeight +
    (currentWidth.value < 768 ? 0 : 0)
    }px`;

    const afterSlide = autoSlide();
    if (afterSlide % firstImgWidth !== 0) {
      videoSliderRef.value[0].scrollLeft =
        firstImgWidth *
        Math.round(
          videoSliderRef.value[0].scrollLeft / firstImgWidth,
        );
    }
  }
};

onMounted(() => {
  isMount.value = true;
  window.addEventListener('resize', resizeHandler);

  if (videoSliderRef.value) {
    const additionalValueML = isMobile.value ? 10 : 14;

    firstImgWidth =
      videoSliderRef.value[0].clientWidth + additionalValueML;
    currentHeightUnactiveItem.value = `${videoSliderRef.value[0].clientHeight}px`;

    currentHeightBlockWithActiveItem.value = `${videoSliderRef.value[0].clientHeight +
    (currentWidth.value < 768 ? 270 : 0)
    }px`;
    scrollWidth =
      videoSliderRef.value[0].scrollWidth -
      videoSliderRef.value[0].clientWidth;
  }

  setTimeout(() => {
    showHideIcons();
  }, 60);
});
onUnmounted(() => {
  window.removeEventListener('resize', resizeHandler);
});
</script>

<style scoped lang="scss">
.gallery-carusel-wrp {
  .panorama-wrp {
    width: 100%;
    max-height: 520px;

    //background: var(--var-video-bg-video);
    .panorama-item {
      height: 520px;
      border-radius: 8px;
      border: none;

      @media (max-width: $md) {
        height: 100%;
        min-height: 225px;
      }
    }
  }
}

.images__wrapper {
  position: relative;
  height: fit-content;
  min-height: 55px;

  .loader__wrapper {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100px;
    height: 55px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: -1;

    @media (max-width: $lg) {
      display: none;
    }
  }
}

.images__wrapper-video {
  position: relative;
  height: fit-content;
  min-height: 55px;

  svg {
    position: absolute;
    top: 24%;
    left: 30%;
    height: 30px;
    cursor: pointer;
  }

  .loader__wrapper {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100px;
    height: 55px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: -1;
  }
}

.gallery-carusel-wrp {
  display: flex;
  gap: 16px;

  @media (max-width: $md) {
    flex-direction: column;
  }

  @media (max-width: 900px) {
    .gallery-carusel-wrp {
      .panorama-wrp {
        .panorama-item {
          border-radius: 8px;
          border: none;
        }

        .panorama-item {
          width: 100%;
        }
      }
    }
  }
}

.wrapper {
  position: relative;
  max-width: 100vw;
  width: 100%;
  display: flex;
  gap: $g-1;

  .wrapper-description {
    overflow: hidden;

    &:has(.wrapper-description_unactive) {
      flex-shrink: 0;
    }

    &:has(.wrapper-description_active) {
      flex-grow: 1;
    }

    &_active {
      position: relative;
      width: 100%;

      overflow: hidden;

      .carousel {
        animation: increaseWidthForActiveItem 0.35s linear;
      }

      @media (max-width: 1200px) {
        min-width: 892px;
      }

      @media (max-width: $lg) {
        min-width: 85vw;
      }

      @media (max-width: $md) {
        min-width: 85vw;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .carousel {
          animation: none;
        }
      }
    }

    &_unactive {
      cursor: pointer;
      width: 64px;
      height: 100%;
      max-height: 520px;
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: 1fr 1fr;

      .unactive_title {
        grid-row: 1/3;
        grid-column: 1/2;
        background: #000000a6;
        display: flex;
        justify-content: center;
        align-items: flex-start;

        span {
          top: auto;
          bottom: 0px;
          width: max-content;
          height: fit-content;
          @include headline-h3;
          transform: rotate(-90deg) translate(50%);
          color: var(--var-white-000);

          &:hover {
            transition: all linear 0.2s;
            background: unset;
          }
        }

        @media (max-width: 768px) {
          display: none;
        }
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: none;
        z-index: -1;
        grid-row: 1/3;
        grid-column: 1/2;
      }

      @media (max-width: $md) {
        position: absolute;
        bottom: -16px;
        max-height: 10px;
        max-width: 10px;
        border-radius: 50%;

        img {
          display: none;
        }
      }
    }

    &:first-child {
      border-top-left-radius: $br-1;
      border-bottom-left-radius: $br-1;

      @media (max-width: 768px) {
        border-top-left-radius: 0;
      }
    }

    &:last-child {
      border-top-right-radius: $br-1;
      border-bottom-right-radius: $br-1;

      @media (max-width: 768px) {
        border-top-left-radius: 0;
      }
    }

    &_br-16 {
      &:first-child {
        border-top-left-radius: $br-6;
        border-bottom-left-radius: $br-6;

        @media (max-width: 768px) {
          border-top-left-radius: 0;
        }
      }

      &:last-child {
        border-top-right-radius: $br-6;
        border-bottom-right-radius: $br-6;

        @media (max-width: 768px) {
          border-top-left-radius: 0;
        }
      }
    }
  }

  .content__count-items {
    position: absolute;
    left: 50%;
    bottom: 8px;
    transform: translateX(-50%);
    z-index: 1000;
    display: flex;
    gap: 2px;
  }

  .content__count-img {
    background-color: rgba(255, 255, 255, 0.2);
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: 1px solid #E1E5F0;
    cursor: pointer;

    &_active {
      background-color: var(--var-white-000);
    }

    @media (max-width: $md) {
    }
  }

  .content__description {
    position: absolute;
    width: 100%;
    bottom: $m-0;
    padding: $p-6 $p-12 $p-10 $p-6;
    left: $m-0;
    z-index: 100;
    background: linear-gradient(360deg,
      #000000 0%,
      rgba(0, 0, 0, 0.3) 78.6%,
      rgba(0, 0, 0, 0) 100%);

    .author-btns {
      position: absolute;
      bottom: 8px;
      color: white;
      left: 50%;
      transform: translateX(-50%);
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;
      gap: $g-2;

      .title {
        padding: $p-1 $p-2;
        border-radius: 25px;
        text-align: center;
        @include launcher-p5;
        cursor: pointer;
        background: rgba(white, 0.2);
        color: var(--var-white-000);
        opacity: 0.9;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        /* number of lines to show */
        line-clamp: 1;
        -webkit-box-orient: vertical;
        line-height: 20px;

        &_active {
          background: var(--var-white-000);
          color: var(--var-black-100);
        }
      }

      @media (max-width: $md) {
        position: unset;
        transform: translateX(0);
        display: grid;
        grid-template-columns: 1fr 1fr;
        bottom: 0px;
        height: fit-content;
        width: 100%;
        max-width: 90vw;

        .title {
          background: none;
          color: var(--var-black-100);

          &_active {
            background: none;
            color: var(--var-blue-50);
          }
        }
      }
    }

    .description__wrapper {
      display: flex;
      gap: $g-8;

      @media (max-width: $md) {
        flex-direction: column-reverse;
        align-items: center;
      }

      .type-btns {
        display: flex;
        gap: $g-2;
        flex-direction: column;

        @media (max-width: $md) {
          flex-direction: row;
        }

        svg {
          cursor: pointer;
          border-radius: 8px;
        }
      }

      .description {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        padding-right: $p-2;

        p {
          font-weight: 300;
        }

        @media (max-width: 1200px) {
          p {
            margin-top: $m-1;
          }
        }

        @media (max-width: $lg) {
          p {
            margin-top: $m-5;
          }
        }

        @media (max-width: $md) {
          p {
            font-weight: 400;
          }
        }
      }

      @media (max-width: $md) {
        gap: 0;
      }
    }

    @media (max-width: $lg) {
      padding: $p-6 $p-10 $p-10 $p-6;
    }

    @media (max-width: $md) {
      padding: $p-0;
      padding-bottom: $p-5;
      position: unset;
      background: unset;
      max-height: 270px;
      //min-height: 270px;
      overflow: hidden;

      h3 {
        color: var(--var-black-100);
      }

      p {
        color: var(--var-black-100);
        margin-bottom: $m-5;
        display: -webkit-box;
        -webkit-line-clamp: 5;
        /* number of lines to show */
        line-clamp: 5;
        -webkit-box-orient: vertical;
      }
    }

    @media (max-width: $md) {
      display: flex;
      flex-direction: column;
    }
  }

  & span {
    top: 50%;
    height: 44px;
    width: 44px;
    color: #343f4f;
    font-size: 1.15rem;
    position: absolute;
    text-align: center;
    line-height: 44px;
    border-radius: 50%;
    transform: translateY(-50%);
    transition: transform 0.1s linear;

    z-index: 100;

    &:active {
      transform: translateY(-50%) scale(0.9);
    }

    &:hover {
      transition: all linear 0.2s;
      background: #a2a2a2;
    }

    svg {
      height: 44px;
      width: 44px;
    }
  }

  &__btn-left {
    left: 12px;
    display: none;
    justify-content: center;
    align-items: center;
  }

  &__btn-right {
    right: 290px;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 1100px) {
      left: 780px;
    }
    @media (max-width: 900px) {
      right: 12px;
      left: auto;
    }
  }

  &__right-bar {
    min-width: 100px;
    max-width: 100px;
    display: flex;
    flex-direction: column;
    gap: $g-4;

    video {
      width: 100px;
      min-height: 55px;
      cursor: pointer;
    }

    img {
      width: 100px;
      min-height: 55px;
      cursor: pointer;
    }

    .item_active {
      border-radius: $br-2;
      border: 5px solid var(--var-blue-100);
      height: fit-content;
    }
  }

  .carousel {
    position: relative;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    scroll-behavior: smooth;

    .video {
      position: relative;
      max-height: 520px;
      background: var(--var-video-bg-video);

      .loader__wrapper {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1;
      }

      @media (max-width: $md) {
        background: transparent;
      }
    }

    .images {
      position: relative;
      background: var(--var-video-bg-video);
      max-height: 520px;

      .loader__wrapper {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: -1;
      }

      @media (max-width: $md) {
        background: transparent;
      }
    }

    img {
      height: 520px;
      width: calc(100% / 1);
      object-fit: cover;
      margin-left: $m-3;

      &:first-child {
        margin-left: 0px;
      }

      @media (max-width: $lg) {
        width: calc(100% / 1);
      }

      @media (max-width: $md) {
        width: 100%;
        height: 100%;
        border-radius: $br-2;
      }
    }

    video {
      height: 520px;
      width: calc(100% / 1);
      object-fit: cover;

      @media (max-width: $lg) {
        width: calc(100% / 1);
      }

      @media (max-width: $md) {
        width: 100%;
        height: 100%;
        border-radius: $br-2;
      }
    }

    .gallery-video-loop {
      margin-left: 14px;

      &_first {
        margin-left: 0px;
      }

      @media (max-width: $md) {
        margin-left: 10px;

        &_first {
          margin-left: 0px;
        }

        border-radius: $br-2;
      }
    }
  }

  .dragging {
    scroll-behavior: auto;

    video::-webkit-media-controls {
      display: none; // Стандартные элементы управления отключены.
    }

    &img {
      pointer-events: none;
      cursor: grab !important;
    }
  }

  @media (max-width: $lg) {
    align-items: end;
  }

  @media (max-width: $md) {
    flex-direction: column;
  }
}

.dragging {
  video {
    cursor: grabbing !important;
  }

  img {
    cursor: grabbing !important;
  }
}

h3 {
  @include headline-h3;
  margin: 0px;
  color: var(--var-white-000);
}

p {
  @include launcher-p2;
  margin: $m-4 0px 0px 0px;
  color: var(--var-white-000);
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  /* number of lines to show */
  line-clamp: 3;
  -webkit-box-orient: vertical;

  @media (max-width: $md) {
    margin: $m-2 0px $m-1 0px;

    -webkit-line-clamp: unset;
    /* number of lines to show */
    line-clamp: unset;
    -webkit-box-orient: vertical;
  }
}

@keyframes increaseWidthForActiveItem {
  0% {
    width: 10%;
  }

  100% {
    width: 100%;
  }
}
</style>
